import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'

const initialState = {
    mappings:     {},
    status:       HTTP_STATUS.IDLE,
    attachStatus: HTTP_STATUS.IDLE,
}

export const fetchPayrollAccountMappings = createAsyncThunk('payrollAccountMapping/fetch', async (_, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.get(BASE_URL + '/api/PayrollAccountMapping')
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const attachPayrollAccountMapping = createAsyncThunk('payrollAccountMapping/attach', async (body, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.post(BASE_URL + '/api/PayrollAccountMapping/attach', body)
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

const PayrollAccountMapping = createSlice({
    name: 'payrollAccountMapping',
    initialState,
    reducers: {
        resetState: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(fetchPayrollAccountMappings.pending, (state) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchPayrollAccountMappings.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                const map = {}
                action.payload.forEach(item => { map[item.key] = item.accounts })
                state.mappings = map
            })
            .addCase(fetchPayrollAccountMappings.rejected, (state) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(attachPayrollAccountMapping.pending, (state) => {
                state.attachStatus = HTTP_STATUS.LOADING
            })
            .addCase(attachPayrollAccountMapping.fulfilled, (state, action) => {
                state.attachStatus = HTTP_STATUS.SUCCEEDED
                state.mappings[action.payload.key] = action.payload.accounts
            })
            .addCase(attachPayrollAccountMapping.rejected, (state) => {
                state.attachStatus = HTTP_STATUS.FAILED
            })
    }
})

export const getPayrollAccountMappings     = (state) => state.payrollAccountMapping.mappings;
export const getPayrollMappingStatus       = (state) => state.payrollAccountMapping.status;
export const getPayrollMappingAttachStatus = (state) => state.payrollAccountMapping.attachStatus;
export const payrollAccountMappingActions  = PayrollAccountMapping.actions;

export default PayrollAccountMapping.reducer;
